(function() {
	document.addEventListener("DOMContentLoaded", function() {
		if(isMobile.iOS()) {

			// remove play button for video in gallery
			let play = document.getElementById("videoPlay");

			if(play instanceof HTMLElement) play.style.opacity = 0;
		}
	});
})();